import React, { useEffect, useState, useRef } from "react";
import { toast } from "sonner";
import api, { fileUrl } from "@/lib/apiClient";
import { AdminHeader, AdminPage } from "@/components/admin/AdminUI";
import { Button } from "@/components/ui/button";
import { Upload, Trash2, FileText, Image as ImageIcon } from "lucide-react";

export default function MediaLibrary() {
  const [items, setItems] = useState([]);
  const [uploading, setUploading] = useState(false);
  const fileRef = useRef();
  const load = () => api.get("/media").then(({ data }) => setItems(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const upload = async (file) => {
    if (!file) return;
    setUploading(true);
    const fd = new FormData(); fd.append("file", file); fd.append("is_public", "true");
    try { await api.post("/media/upload", fd); toast.success("Uploaded"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Upload failed"); } finally { setUploading(false); }
  };
  const del = async (m) => { if (!window.confirm("Archive this file?")) return; await api.delete(`/media/${m.id}`); toast.success("Archived"); load(); };

  return (
    <>
      <AdminHeader title="Media Library" subtitle={`${items.length} files`} actions={
        <Button onClick={() => fileRef.current?.click()} disabled={uploading} className="bg-npst-navy text-white" data-testid="media-upload-btn"><Upload size={15} className="mr-1.5" /> {uploading ? "Uploading…" : "Upload File"}</Button>
      } />
      <input ref={fileRef} type="file" accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.webp" className="hidden" onChange={(e) => upload(e.target.files[0])} />
      <AdminPage>
        {items.length === 0 ? <p className="text-slate-400 text-sm">No files yet.</p> : (
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-4">
            {items.map((m) => {
              const isImg = ["jpg", "jpeg", "png", "webp"].includes((m.ext || "").toLowerCase());
              return (
                <div key={m.id} className="bg-white border border-slate-200 rounded-lg overflow-hidden group">
                  <div className="aspect-square bg-slate-50 flex items-center justify-center">
                    {isImg && m.is_public ? <img src={fileUrl(m.storage_path)} alt={m.alt_text || m.display_filename} className="w-full h-full object-cover" />
                      : <div className="text-slate-300 flex flex-col items-center gap-1">{isImg ? <ImageIcon size={30} /> : <FileText size={30} />}<span className="text-[10px] uppercase font-mono">{m.ext}</span></div>}
                  </div>
                  <div className="p-2">
                    <div className="text-xs text-npst-ink truncate" title={m.display_filename}>{m.display_filename}</div>
                    <div className="flex items-center justify-between mt-1">
                      <span className="text-[10px] text-slate-400">{Math.round((m.size || 0) / 1024)} KB</span>
                      <button onClick={() => del(m)} className="text-slate-300 hover:text-red-600"><Trash2 size={13} /></button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </AdminPage>
    </>
  );
}
